import api from "../api";

export const hasOwnershipUpdates = (customer: api.CompanyCustomerDetailResponse) =>
  Boolean(customer.unhandled_ownership_updates && customer.unhandled_ownership_updates > 0);
